<script lang="ts">
import { defineComponent } from 'vue';
import { formatDate } from '@/utils/format';
import ClipboardIcon from '@/components/clipboard-icon.vue';

export default defineComponent({
  name: 'fixture',
  components: { ClipboardIcon },
  computed: {
    info() {
      const values = [
        { name: 'Раунд', value: this.fixture.Round?.Name },
        { name: 'Сезон', value: this.fixture.Season?.Name },
        { name: 'Место проведения', value: this.fixture.Venue?.Name },
        { name: 'Регион', value: this.fixture.Competition.Region?.Name },
        { name: 'Спорт', value: this.fixture.Sport.Name },
        { name: 'Начало', value: formatDate(this.fixture.StartTimeUtc, 'DD.MM.YYYY HH:mm') },
      ];

      return values.filter((v) => v.value);
    },
  },
  emits: ['update:section'],
  methods: { formatDate },
  props: ['fixture', 'section', 'sections', 'refresh'],
});
</script>

<template>
  <div class="grid grid-cols-[max-content_max-content_1fr] gap-y-1 gap-x-4">
    <span class="mb-1">
      <span class="text-blue-500">
        {{ fixture.FixtureType }}
      </span>
    </span>
    <span>
      {{ fixture.Name }}
      <clipboard-icon :text="fixture.Name" />
      <a
        :href="`https://coins.game/sport_coins/ru/event/${fixture.Id}`"
        class="ml-2 inline-block rounded px-2 text-blue-500"
        target="_blank"
      >
        Карточка события на Coins.Game
      </a>
    </span>
    <span class="ml-auto">
      <span v-if="fixture.IsBooked" class=""> Booked </span>
      <span
        :class="{
          'text-green-500': fixture.EventStatusType === 'Inprogress',
          'text-blue-500': fixture.EventStatusType === 'Prematch',
          'text-red-500': fixture.EventStatusType === 'Finished',
        }"
      >
        {{ fixture.EventStatusType }}
      </span>
      <span class="text-gray-700 dark:text-gray-300 font-mono ml-1">
        {{ fixture.Id }}
        <clipboard-icon :text="fixture.Id" />
      </span>
    </span>

    <span class="dark:text-gray-400">Турнир</span>
    <span class="text-gray-500 dark:text-gray-500">
      {{ fixture.Competition?.Name }}
      <clipboard-icon :text="fixture.Competition?.Name" />
      {{ fixture.Competition?.Id }}
      <clipboard-icon :text="fixture.Competition?.Id" />
    </span>
    <span class="ml-auto">
      <template v-for="(section, index) in sections" :key="section.id">
        <span
          @click="$emit('update:section', section.id)"
          class="text-blue-500 underline cursor-pointer hover:text-blue-600 dark:hover:text-blue-400"
        >
          {{ section.name }}
        </span>
        <span v-if="index < sections.length - 1" class="text-blue-500 cursor-pointer"> | </span>
      </template>
    </span>

    <template v-for="(item, i) in info">
      <span class="dark:text-gray-400">{{ item.name }}</span>
      <span class="text-gray-500 dark:text-gray-500">{{ item.value }}</span>
      <span v-if="i === info.length - 1" class="ml-auto">
        <i class="pi pi-refresh cursor-pointer" @click="refresh" />
      </span>
      <span v-else />
    </template>
  </div>
</template>

<style scoped lang="scss"></style>
